import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { ClipboardCheck, Loader2, ArrowRight } from "lucide-react";

export const ArchiveCoverageWidget = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/documents/required-docs/report")
            .then((r) => setData(r.data))
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    if (loading) {
        return (
            <section className="rounded-lg border border-slate-200 bg-white p-5 shadow-sm" data-testid="archive-coverage-widget">
                <div className="flex items-center justify-center py-6">
                    <Loader2 className="h-5 w-5 animate-spin text-slate-300" />
                </div>
            </section>
        );
    }
    if (!data) return null;

    return (
        <section className="flex flex-1 flex-col rounded-lg border border-slate-200 bg-white p-5 shadow-sm" data-testid="archive-coverage-widget">
            <h2 className="mb-1 flex items-center gap-2 font-display text-base font-semibold text-slate-700">
                <ClipboardCheck className="h-4 w-4 text-[#376DB3]" />
                Documenti obbligatori
            </h2>
            <p className="mb-3 text-xs text-slate-500">
                Dipendenti attivi con fascicolo completo: <b>{data.complete}/{data.total_active}</b>
            </p>
            <div className="flex-1 space-y-2.5">
                {data.checks.map((c) => {
                    const missing = data.totals[c.key] || 0;
                    const present = data.total_active - missing;
                    const pct = data.total_active > 0 ? Math.round((present / data.total_active) * 100) : 0;
                    const complete = missing === 0 && data.total_active > 0;
                    return (
                        <div key={c.key} data-testid={`coverage-row-${c.key}`}>
                            <div className="flex items-center justify-between text-xs">
                                <span className="font-medium text-slate-600">{c.label}</span>
                                <span className="font-mono-numbers text-slate-500">
                                    <span className={complete ? "font-semibold text-emerald-600" : "font-semibold text-slate-700"}>{present}</span>
                                    /{data.total_active}
                                </span>
                            </div>
                            <div className="mt-1 flex items-center gap-2">
                                <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-slate-100">
                                    <div
                                        className={`h-full rounded-full transition-[width] duration-500 ${complete ? "bg-emerald-500" : pct >= 50 ? "bg-[#376DB3]" : "bg-amber-500"}`}
                                        style={{ width: `${pct}%` }}
                                    />
                                </div>
                                {missing > 0 ? (
                                    <Link
                                        to={`/documenti/mancanti?check=${c.key}`}
                                        className="whitespace-nowrap text-[10px] font-semibold text-amber-700 hover:underline"
                                        data-testid={`coverage-missing-btn-${c.key}`}
                                    >
                                        {missing} mancanti
                                    </Link>
                                ) : (
                                    <span className="text-[10px] font-semibold text-emerald-600">✓</span>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
            <Link
                to="/documenti/mancanti"
                className="mt-4 flex items-center justify-end gap-1 text-xs font-semibold text-[#376DB3] hover:underline"
                data-testid="coverage-report-link"
            >
                Vedi resoconto completo <ArrowRight className="h-3 w-3" />
            </Link>
        </section>
    );
};
